import { FC } from 'react'

import RFFFields from '../../react-final-form-fields'
import { validateRequired, validateMaxSymbols, composeValidators } from '../../../../util/validation'
import { nameofFactory, getPlaceholderTextFromLabel } from '../../../../util'

import { TrainingCategoryFormFieldsProps, ITrainingCategoryValues } from './training-category-form-types'

const validateMaxSymbols100 = validateMaxSymbols(100, 'Field must not exceed 100 characters')

const nameof = nameofFactory<ITrainingCategoryValues>()

const nameLabel = 'Name'
const sortOrderLabel = 'Sort Order'
const activeLabel = 'Active'

const TrainingCategoryFormFields: FC<TrainingCategoryFormFieldsProps> = props => {
  const { disabled } = props

  return (
    <>
      <RFFFields.Input
        name={nameof('name')}
        label={nameLabel}
        placeholder={getPlaceholderTextFromLabel(nameLabel)}
        disabled={disabled}
        validate={composeValidators(validateRequired, validateMaxSymbols100)}
      />

      <RFFFields.MaskedInput
        type="number"
        name={nameof('sortOrder')}
        label={sortOrderLabel}
        placeholder={getPlaceholderTextFromLabel(sortOrderLabel)}
        disabled={disabled}
      />

      <RFFFields.Switch name="isActive" label={activeLabel} onLabel="yes" offLabel="no" disabled={disabled} />
    </>
  )
}

export default TrainingCategoryFormFields
